import $ from 'jquery';
import Class from '../EventListingViewClasses';
import { endOfDay, isBetweenDates } from '../date/DateHelpers';
import { loadDatePicker } from '../Loaders';
import { makeBusyIndicatorHtml } from '../htmlShared';

const HTML = `
  <div class="${Class.CONTROLS_CONTAINER}"></div>
  <div class="${Class.RESULTS_CONTAINER}"></div>
`;

class CalendarResultBaseView {
  constructor(store, config, mode) {
    this.store = store;
    this.config = config;
    this.mode = mode;
    this.isCurrentView = false;
    this.selectedDate = null;
    this.startDate = null;
    this.endDate = null;
    this.selectedDate = config.defaultDisplayDate;

    this.$el = $(`#tn-events-calendar-view-${mode}`);
    this.$el.html(HTML);
    this.$el.append(makeBusyIndicatorHtml());

    this.$results = this.$el.find(`.${Class.RESULTS_CONTAINER}`);
    this.$controls = this.$el.find(`.${Class.CONTROLS_CONTAINER}`);

    this.store.on('date', this.onSelectedDateUpdated.bind(this));
    this.store.on('mode', this.onModeUpdate.bind(this));

    this.store.on('fetchStart', () => {
      this.$el.addClass(Class.LOADING_MODIFIER);
    });

    this.store.on('fetchEnd', () => {
      this.$el.removeClass(Class.LOADING_MODIFIER);
    });

    this.store.on('fetchFailed', () => {
      this.$el.removeClass(Class.LOADING_MODIFIER);
      this.resultViews.forEach(view => view.clearResults());
    });

    loadDatePicker().then((DatePicker) => {
      this.initDatepicker(DatePicker, {
        date: config.defaultDisplayDate,
        minDate: config.earliestEventDate,
        maxDate: config.latestEventDate,
      });

      this.$controls.append(this.datePicker.$el);
    });
  }

  setResultViews(views) {
    this.resultViews = views;
    this.resultViews.forEach(view => this.$results.append(view.$el));
  }

  onModeUpdate({ mode }) {
    this.isCurrentView = this.mode === mode;

    if (this.isCurrentView) {
      this.show();
    }
  }

  onDateChange(date) {
    this.selectedDate = date;
    this.store.emit('date', { date });
  }

  onSelectedDateUpdated({ date }) {
    this.selectedDate = date;
  }

  setSelectedDate(date) {
    if (this.datePicker) {
      this.datePicker.setDate(date);
    }
    this.onDateChange(date);
  }

  show() {
    this.setSelectedDate(this.selectedDate);
  }

  setData(data) {
    this.renderResults(data);
  }

  renderResults(perfMap) {
    const { startDate, endDate } = this.getRangeForSelectedDate();

    // Use only the perfs that fall within our viewing date range:
    const filteredPerfMap = new Map();
    perfMap.forEach((perfs, key) => {
      const perfDate = perfs[0].iso8601Date;
      if (isBetweenDates(perfDate, startDate, endDate)) {
        filteredPerfMap.set(key, perfs);
      }
    });

    this.resultViews.forEach(view => view.renderResults(filteredPerfMap, this.selectedDate));
  }
}

export default CalendarResultBaseView;



// WEBPACK FOOTER //
// ./V7/events/listing/calendarView/CalendarModeBaseView.js